import { JsonObject, JsonProperty } from 'json2typescript';
import { NameAndCode } from './name-code-model';

@JsonObject('Warehouse')
export class Warehouse extends NameAndCode {
  @JsonProperty('logisticPartner', String, true) logisticPartner: string = undefined;
  @JsonProperty('connectionName', String, true) connectionName: string = undefined;
}
